module.exports = __webpack_public_path__ + "static/media/noun_paid_green_1820672.094b7c1b.svg";